/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.mvpd').service('MVPDViewService', function (this: JS5Object, _: JS5Object,
																		 MetadataService: JS5Object,
																		 MetadataEditService: JS5Object) {
	let _componentsMap = {};

	let getProps = (properties: JS5Object[]) => {
		let props: JS5Object = {};
		angular.forEach(properties, (prop, name) => {
			props[name] = prop;
		});
		return props;
	};

	this.permissionViewState = 'MVPD_VIEW_STATE';
	this.editorForm = undefined;
	this.originalEditData = {};

	this.getComponentsMap = (newComponentsMap: JS5Object) => {
		if (newComponentsMap) {
			_componentsMap = newComponentsMap;
		}
		return _componentsMap;
	};

	this.getMetadataByGroup = (groupName: string, editData: JS5Object) => {
		return MetadataEditService.getMetadataByGroup(groupName).then((properties: JS5Object[]) => {
			let componentsMap = {};

			this.metadataProperties = properties;

			if (editData.metadata) {
				componentsMap = this.buildComponentsMap(editData);
			} else {
				var metadataItems = this.metadataProperties.reduce((mappedItems: JS5Object[], metadataItem: JS5Object) => {
					mappedItems[metadataItem.name] = {required: false, valueOverridden: false};
					return mappedItems;
				}, {});

				componentsMap = MetadataService.buildCustomComponentMap(metadataItems, undefined, true, MetadataService.textListInputProps.delimiter, MetadataService.textListInputProps.objectKey);
			}

			this.getComponentsMap(componentsMap);
			return editData;
		});
	};

	this.buildComponentsMap = (editData: JS5Object) => {
		var allComponents = MetadataService.buildCustomComponentMap(editData.metadata.properties, undefined, true, MetadataService.textListInputProps.delimiter, MetadataService.textListInputProps.objectKey);

		return getProps(allComponents);
	};

	this.revertMVPDEditData = () => {
		_.forEach(this.getComponentsMap(undefined), (comp: JS5Object, key: string) => {
			comp.instanceData.value = this.originalEditData.metadata.properties[key].value;
		});

		return this.getComponentsMap(undefined);
	};

	this.getFieldErrorsTooltip = (missingMVPDFields: JS5Object[]): string => {
		return `Missing ${missingMVPDFields.length} Input Value(s): ${_.join(missingMVPDFields, ', ')}`;
	};
});
